import { lazy } from 'react';
import { type RouteObject, useParams } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';
import { useWebshopDetailsQuery } from '~/domain/webshop/api';

const IndexPage = lazy(() => import('./pages/index'));
const IssuePage = lazy(() => import('./pages/issue'));
const RevokePage = lazy(() => import('./pages/revoke'));

export default {
    path: '/webshops',
    title: 'Webshopovi',
    children: [{
        path: ':webshopId',
        Title: () => {
            const { webshopId } = useParams<{ webshopId: string }>();
            const { data } = useWebshopDetailsQuery(webshopId!, { skip: !webshopId });
            return data ? data.domain : null;
        },
        children: [{
            path: 'api-keys',
            title: 'Api Ključevi',
            Component: IndexPage,
            children: [{
                Component: ModalOutlet,
                children: [{
                    path: 'issue',
                    Component: IssuePage,
                }, {
                    path: ':prefix/revoke',
                    Component: RevokePage,
                }],
            }],
        }],
    }],
} satisfies RouteObject;
